import React from "react";
import RequestPageMUI from "./RequestPageMUI";

const DanaAtHome = () => {
    return (
        <RequestPageMUI 
            title="Dana At Home Requests"
            fetchUrl="/get-dana-at-home-requests"
            editEndpoint="edit-dana-at-home-request"
            deleteEndpoint="dana-at-home-request"
            statusEndpoint="dana-at-home-request"
            dateFields={['date', 'created_at', 'updated_at']}
            hiddenFields={['ip_address']} // Hide IP address from view if your data has it
            // You can customize further based on your Dana At Home data structure
        />
    );
};

export default DanaAtHome;